// import axiosInstance from "global/helpers/axiosInstance";
import axiosLogin from "global/helpers/axiosLogin";
import axiosInstance from "global/helpers/axiosInstance";
import {
  ORDENDIGITAL_SUCCESS,
  ORDENDIGITAL_LOADING,
  ORDENDIGITAL_ERROR,
  ORDENDIGITALGRUPO_SUCCESS,
  ORDENDIGITAL_RESET,
  ORDENDIGITAL_ALTATURNO_SET,
  ORDENDIGITAL_LOAD,
  ORDENDIGITAL_FLGVOLVER,
  ORDENDIGITAL_SOLICITANTE,
  ORDENDIGITAL_FECHA_SET,
  ORDENDIGITALPDF_SUCCESS,
  ORDENDIGITALPDF_LOADING,
  ORDENDIGITALPDF_ERROR,
  ORDENDIGITALPDF_RESET,
} from "../../ActionTypes";

export const wsGetOrdenDigitalEstudio =
  (idPaciente, nextStep) => (dispatch) => {
    dispatch({
      type: ORDENDIGITAL_LOADING,
    });

    axiosLogin().then((respuesta) => {
      respuesta
        .get(`/his/ordenes-digitales/misOrdenes`)
        .then((res) => {
          dispatch({
            type: ORDENDIGITAL_SUCCESS,
            payload: res.data,
          });
          if (nextStep) nextStep(true, res.data);
        })
        .catch((err) => {
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
          };

          dispatch({
            type: ORDENDIGITAL_ERROR,
            payload: error,
          });
          if (nextStep) nextStep(false, error.detail);
        });
    });
  };
// export const wsGetOrdenDigitalEstudio =
//   (idPaciente, nextStep) => (dispatch) => {
//     dispatch({
//       type: ORDENDIGITAL_LOADING,
//     });

//     axiosLogin().then((respuesta) => {
//       respuesta
//         .get(`/OrdenDigital/GetByIDPACIENTE/${idPaciente}`)
//         .then((res) => {
//           dispatch({
//             type: ORDENDIGITAL_SUCCESS,
//             payload: res.data,
//           });
//           if (nextStep) nextStep(true, res.data);
//         })
//         .catch((err) => {
//           let error = {
//             detail: err.response
//               ? err.response.data
//               : "Error al contactar el server.",
//           };

//           dispatch({
//             type: ORDENDIGITAL_ERROR,
//             payload: error,
//           });
//           if (nextStep) nextStep(false, error.detail);
//         });
//     });
//   };

export const wsGetGrupoByIdOrden = (id, nextStep) => (dispatch) => {
  dispatch({
    type: ORDENDIGITAL_LOADING,
  });

  axiosLogin().then((respuesta) => {
    respuesta
      .get(`/his/ordenes-digitales/items/${id}`)
      .then((res) => {
        dispatch({
          type: ORDENDIGITALGRUPO_SUCCESS,
          payload: res.data,
        });
        if (nextStep) nextStep(true, res.data);
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
        };

        dispatch({
          type: ORDENDIGITAL_ERROR,
          payload: error,
        });
        if (nextStep) nextStep(false, error.detail);
      });
  });
};
// export const wsGetGrupoByIdOrden = (id, nextStep) => (dispatch) => {
//   dispatch({
//     type: ORDENDIGITAL_LOADING,
//   });

//   axiosLogin().then((respuesta) => {
//     respuesta
//       .get(`/OrdenDigital/items/${id}`)
//       .then((res) => {
//         dispatch({
//           type: ORDENDIGITALGRUPO_SUCCESS,
//           payload: res.data,
//         });
//         if (nextStep) nextStep(true, res.data);
//       })
//       .catch((err) => {
//         let error = {
//           detail: err.response
//             ? err.response.data
//             : "Error al contactar el server.",
//         };

//         dispatch({
//           type: ORDENDIGITAL_ERROR,
//           payload: error,
//         });
//         if (nextStep) nextStep(false, error.detail);
//       });
//   });
// };

export const wsGetPDFOrdenEstudio = (id, nextStep) => (dispatch) => {
  dispatch({ type: ORDENDIGITALPDF_LOADING });
  axiosLogin().then((respuesta) => {
    respuesta
      .get(`/his/ordenes-digitales/pdf/${id}/pdf`, { responseType: "blob" })
      .then((resp) => {
        const blob = resp.data;
        dispatch({
          type: ORDENDIGITALPDF_SUCCESS,
          payload: null,
        });
        if (nextStep) nextStep(true, { blob });
      })
      .catch((err) => {
        dispatch({ type: ORDENDIGITALPDF_ERROR, payload: err.data });
        if (nextStep) nextStep(false, err.response.data);
      });
  });
};
/* export const wsGetPDFOrdenEstudio = (id, nextStep) => (dispatch) => {
  dispatch({ type: ORDENDIGITALPDF_LOADING });
  axiosInstance().then((respuesta) => {
    respuesta
      .get(`/OrdenDigital/GetPDF/${id}`)
      .then((resp) => {
        dispatch({
          type: ORDENDIGITALPDF_SUCCESS,
          payload: resp.data,
        });
        if (nextStep) nextStep(true, resp.data);
      })
      .catch((err) => {
        dispatch({ type: ORDENDIGITALPDF_ERROR, payload: err.data });
        if (nextStep) nextStep(false, err.response.data);
      });
  });
}; */

export const setMedicoSolicitante = (idMedico) => (dispatch) => {
  dispatch({
    type: ORDENDIGITAL_SOLICITANTE,
    payload: idMedico,
  });
};

export const resetPDFOrdenEstudio = () => (dispatch) => {
  dispatch({
    type: ORDENDIGITALPDF_RESET,
  });
};

export const setLoadingOrdenDigitalEstudio = (loading) => (dispatch) => {
  dispatch({
    type: ORDENDIGITAL_LOAD,
    payload: loading,
  });
};

export const setAltaOrdenDigitalEstudio = (ordenDigital) => (dispatch) => {
  dispatch({
    type: ORDENDIGITAL_ALTATURNO_SET,
    payload: ordenDigital,
  });
};

export const setFlgVolverOrdenDigitalEstudio = (flgVolver) => (dispatch) => {
  dispatch({
    type: ORDENDIGITAL_FLGVOLVER,
    payload: flgVolver,
  });
};

// Fecha de la orden (postdatada) para arrancar la búsqueda de turnos desde esa fecha
// y validar al confirmar que el turno no sea anterior.
export const setFechaOrdenDigital = (fecha) => (dispatch) => {
  dispatch({
    type: ORDENDIGITAL_FECHA_SET,
    payload: fecha,
  });
};

export const resetOrdenDigitalEstudio = () => (dispatch) => {
  dispatch({
    type: ORDENDIGITAL_RESET,
  });
};
